import { createGlobalStyle } from "styled-components";
import { CommonGlobal } from "../commons/styles/commonGlobalStyle";
// import { ResetStyle } from "./reset";
import { type Theme } from "./theme";

export const GlobalStyle = createGlobalStyle<{ theme: Theme }>`
${CommonGlobal};
:root {
  --primary: ${props => props.theme.colors.primary};
  --btn-primary: ${props => props.theme.colors.btnPrimary};
  --btn-primary-hover: ${props => props.theme.colors.btnPrimaryHover};

  --secondary: ${props => props.theme.colors.secondary};
  --btn-secondary: ${props => props.theme.colors.secondary};
  --btn-secondary-hover: ${props => props.theme.colors.btnSecondaryHover};
}

html {
  height: 100%;
}
body {
  position: relative;
  height: 100%; 
}

.wrapper {
  height: 100%;
}
::-moz-selection {
  background: #0066ff44;
  text-shadow: none;
}

::selection {
  background: #0066ff44;
  text-shadow: none;
}
  
::-webkit-scrollbar{
  width: 4px;
  /* height: 112px; */
}
::-webkit-scrollbar-track{
   /* background-color: #e4e4e4; */
  border-radius: 100px;
}
::-webkit-scrollbar-thumb {
  border-radius: 100px;
  background-color: #d7d7d7;
  /* box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3); */
}
`;
